import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatrixFromToRow, MatrixTipDocumentBreakdownItem } from '../../raport-activitate-detaliat.interface';

@Component({
    selector: 'app-matrix-from-to-table',
    templateUrl: './matrix-from-to-table.component.html',
    styleUrls: ['./matrix-from-to-table.component.scss'],
})
export class MatrixFromToTableComponent {
    @Input() rows: MatrixFromToRow[] = [];
    @Input() selectedRow: MatrixFromToRow | null = null;
    @Input() truncated = false;

    @Output() rowClick = new EventEmitter<MatrixFromToRow | null>();
    @Output() tipDocumentClick = new EventEmitter<{ row: MatrixFromToRow; tipDocumentId: number }>();

    onRowClick(row: MatrixFromToRow): void {
        if (this.selectedRow?.drill_key === row.drill_key) {
            this.rowClick.emit(null);
        } else {
            this.rowClick.emit(row);
        }
    }

    onChipTipClick(row: MatrixFromToRow, item: MatrixTipDocumentBreakdownItem, event: Event): void {
        event.stopPropagation();
        this.tipDocumentClick.emit({ row, tipDocumentId: item.id });
    }

    /** Căutare client-side în lista de tipuri a fiecărui rând (cheie = drill_key). */
    tipSearch: Record<string, string> = {};

    private readonly TIP_TOP = 5;
    private readonly TIP_SEARCH_MAX = 25;

    onTipSearch(row: MatrixFromToRow, event: Event): void {
        event.stopPropagation();
        this.tipSearch[row.drill_key] = (event.target as HTMLInputElement).value ?? '';
    }

    isTipSearching(row: MatrixFromToRow): boolean {
        return (this.tipSearch[row.drill_key] ?? '').trim().length >= 1;
    }

    totalTypes(row: MatrixFromToRow): number {
        return row.tipuri_document_breakdown?.length ?? 0;
    }

    visibleTypes(row: MatrixFromToRow): MatrixTipDocumentBreakdownItem[] {
        const all = row.tipuri_document_breakdown ?? [];
        const q = (this.tipSearch[row.drill_key] ?? '').trim().toLowerCase();
        if (q.length >= 1) {
            return all.filter((t) => (t.name ?? '').toLowerCase().includes(q)).slice(0, this.TIP_SEARCH_MAX);
        }
        return all.slice(0, this.TIP_TOP);
    }

    hiddenTypesCount(row: MatrixFromToRow): number {
        return Math.max(0, this.totalTypes(row) - this.TIP_TOP);
    }

    keys(obj: Record<string, number> | null | undefined): string[] {
        return obj ? Object.keys(obj) : [];
    }
}
